export const isPasswordValid = (password) => {
    const hasMinimumLength = password.length >= 6;
    const hasLetter = /[a-zA-Z]/.test(password);
    const hasDigit = /\d/.test(password);
  
    return hasMinimumLength && hasLetter && hasDigit;
};